module.exports = __webpack_public_path__ + "static/media/green bean.aa197c9b.jpg";